import { CreateCommentInDto, CreateCommentOutDto } from '../../../types/comment.dto';

export const NEW_COMMENT = 'NEW_COMMENT';
export const NEW_COMMENT_SUCCESS = 'NEW_COMMENT_SUCCESS';
export const NEW_COMMENT_ERROR = 'NEW_COMMENT_ERROR';
export const RESET_NEW_COMMENT = 'RESET_NEW_COMMENT';

export interface NewComment {
  type: typeof NEW_COMMENT;
  payload: CreateCommentOutDto;
}

export interface NewCommentSuccess {
  type: typeof NEW_COMMENT_SUCCESS;
  payload: CreateCommentInDto;
}

export interface NewCommentError {
  type: typeof NEW_COMMENT_ERROR;
  payload: string | boolean;
}

export interface ResetNewComment {
  type: typeof RESET_NEW_COMMENT;
  payload: null;
}

export interface State {
  data: CreateCommentInDto | null;
  states: {
    success: boolean;
    loading: boolean;
    error: boolean | string;
  };
}

export const initialState: State = {
  data: null,
  states: {
    success: false,
    loading: false,
    error: false,
  },
};

export type Actions = NewComment | NewCommentSuccess | NewCommentError | ResetNewComment;
